import Component from '../inherited/Component'
import productCardTemplate from '../lib/product-card-template'

export default class RecentlyViewed extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount() {
    if (this._options.handle) {
      this.handleStoreViewedProduct(this._options.handle)
    }

    if (this._elem.querySelector('[data-recently-viewed-products]')) {
      const limit = this._options.limit || 6

      this.handleFetchProducts(limit)
    }
  }

  handleRenderProducts(products) {
    const productWrapper = this._elem.querySelector(
      '[data-recently-viewed-products]'
    )

    products.forEach(product => {
      productWrapper.innerHTML += productCardTemplate(product)
    })

    this._theme.mountComponents(this._elem)
  }

  async handleFetchProducts(limit) {
    let recentlyViewed = localStorage.getItem('runlimited-recently-viewed')

    if (recentlyViewed) {
      recentlyViewed = JSON.parse(recentlyViewed)
    } else {
      recentlyViewed = []
    }

    if (recentlyViewed.length === 0) {
      this._elem.classList.add('hide')
    }

    const promises = []
    const handles = recentlyViewed.slice(0, limit)

    handles.forEach(handle => {
      const promise = fetch(`/products/${handle}.js`).then(res => res.json())
      promises.push(promise)
    })

    const products = await Promise.all(promises)

    this.handleRenderProducts(products)
  }

  handleStoreViewedProduct(handle) {
    let recentlyViewed = localStorage.getItem('runlimited-recently-viewed')

    if (recentlyViewed) {
      recentlyViewed = JSON.parse(recentlyViewed)
    } else {
      recentlyViewed = []
    }

    if (recentlyViewed.indexOf(handle) === -1) {
      recentlyViewed.unshift(handle)

      localStorage.setItem(
        'runlimited-recently-viewed',
        JSON.stringify(recentlyViewed)
      )
    }
  }
}
